import { FirstMomentsTab } from "@/components/user-record/first-moments-tab";
import { useCurrentUser } from "@/lib/api/user";
import { Skeleton } from "@somethings-ui/web";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/profile/first-moments")({
  component: ProfileFirstMomentsPage,
});

function ProfileFirstMomentsPage() {
  const { data: user } = useCurrentUser();

  if (!user) {
    return <Skeleton className="h-40 w-full" />;
  }

  return <FirstMomentsTab userId={user.id} />;
}
